<template>
  <div>
    <div v-if="!openPatientCard" class="w3-col w3-margin-bottom w3-center flow-padding-bottom">
      <h5 v-if="noRoomsLinked" class="flow-blue-color zero-bottom zero-top">

        <p class="zero">
          mini
          <i class="fa fa-exclamation-triangle w3-text-deep-orange flow-margin-right"></i>
          <span class="w3-text-red font-weight-bold w3-margin-right w3-hover-opacity-off">
                        {{ $t('noRoomsLinked') }}. {{ $t('linkRoomInfo') }}
                    </span>

          <router-link :to="{name: 'rooms'}" class="flow-btn w3-btn w3-round-medium flow-blue-color">
            <i class="fa fa-door-open flow-green-active-color"></i>
            {{ $t('link') }}
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </p>

      </h5>

      <span v-else
            v-for="room in rooms"
            class="consultation-room w3-round-medium font-weight-bold w3-padding w3-margin-right flow-blue-color w3-large">
                    {{room.displayName}}
            </span>
    </div>

    <div v-if="room.group.autoCallPatients">
      <!--show pause and resume consultation section-->
    </div>

    <div v-bind:class="openPatientCard ? 'w3-container content-sidebars sidebars-50-50' : 'flow-main-content w3-margin-bottom'">

      <div v-bind:class="openPatientCard ? 'zero w3-col content-sidebar-left' : 'w3-col w3-margin-top w3-margin-bottom'">

        <PatientsForCallerMinimalRoom :currentRoom="currentRoom" :patients="patients" :onSelectCallback="openPatient"
                                      :openPatientCard="openPatientCard" :physician="physician"
                                      :roomActions="roomActions"></PatientsForCallerMinimalRoom>
      </div>

      <div v-if="openPatientCard"
           class="w3-col content-sidebar-right top-from-header w3-animate-right flow-padding-top">
        <patient-side-card class="flow-padding-top"
                           :selectedPatient="selectedPatient"
                           :selectedPatientStatus="selectedPatient.status"
                           :selectedPatientDevice="selectedPatient.device"
                           :onClose="() => {openPatientCard = false;}"></patient-side-card>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import ContentHeader from "../common/ContentHeader";
    import PatientSideCard from "../patient/PatientSideCard";
    import PatientsForCallerMinimalRoom from "./PatientsForCallerMinimalRoom"
    import Loading from "../common/Loading";
    import PatientStatus from "../common/PatientStatus";
    import {EventBus} from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "ConsultationInMinimalRoom",
        props: ['room', 'propsPhysician', 'hasMinimalStructure'],
        components: {
            Loading, PatientSideCard, PatientsForCallerMinimalRoom, ContentHeader, PatientStatus
        },
        data() {
            return {
                rooms: [],
                physician: {},
                currentRoomId: undefined,
                patients: [],
                wardId: undefined,
                roomActions: [],
                openPatientCard: false,
                selectedPatient: {},
                refreshIntervalId: undefined,
                patientRefreshIntervalId: undefined,
                currentRoom: undefined
            }
        },
        computed: {
            isPhysicianActive() {
                return this.physician && this.physician.status === 'Active';
            },
            noRoomsLinked() {
                return this.rooms.length === 0;
            }
        },
        mounted() {
            if (!this.propsPhysician) {
                Vue.notifyError({
                    title: this.$t("NO_PHYSICIAN_LINKED")
                });
                return;
            }

            this.physician = this.propsPhysician;

            this.wardId = this.physician.ward.id;

            if (this.room.id) {
                this.currentRoomId = this.room.id;
                this.currentRoom = this.room;
                this.getRoomActions();
                this.checkAndActivatePhysician();
            }

            this.refreshIntervalId = setInterval(this.refresh, 8000);
            this.patientRefreshIntervalId = setInterval(this.refreshPatients, 5000);
            EventBus.$on("patientUpdated", this.updateStatus);
        },
        beforeDestroy() {
            clearInterval(this.refreshIntervalId);
            clearInterval(this.patientRefreshIntervalId);
            EventBus.$off("patientUpdated", this.updateStatus);
        },
        watch: {
            physician() {
                this.physician.active = this.physician.status === 'Active';
                this.getPatientsForPhysician();

                var rooms = this.physician ? this.physician.rooms : undefined;
                if (!rooms || rooms.length < 1) {
                    this.rooms = [];
                    return;
                }

                Vue.sortByKey(rooms, 'displayName');
                this.rooms = rooms;
                this.checkAndActivatePhysician();
            }
        },
        methods: {
            refresh() {
                this.getPhysician();
            },
            refreshPatients() {
                this.getPatientsForPhysician();
            },
            checkAndActivatePhysician() {
                if (!this.room.group.autoCallPatients && !this.isPhysicianActive) {
                    frc.activatePhysician(this.physician.ward.id, this.physician.id).then(function (res) {
                        console.log("activated physician");
                    }).catch(function (ex) {
                        console.log("failed to activate physician");
                    })
                }
            },
            getRoomActions() {
                const app = this;
                frc.getRoomActions(this.wardId, this.currentRoomId).then(function (res) {
                    app.roomActions = res.data;
                    if (app.roomActions.length < 1) {
                        console.log("No room actions configured");
                    }
                });
            },
            getPatientsForPhysician() {
                const app = this;
                frc.getPatientsForPhysician(this.wardId, this.physician.id).then(function (res) {
                    app.patients = res.data;
                });
            },
            getPhysician() {
                const app = this;
                frc.getPhysicianWithId(app.physician.id).then(function (res) {
                    app.physician = res.data;
                });
            },
            openPatient(patient) {
                this.selectedPatient = patient;
                this.openPatientCard = true;
            },
            updateStatus(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id, patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Patient not found.");
                        return;
                    }
                    app.selectedPatient.status = res.data.status;
                });
            }
        }
    }
</script>